module.exports = __webpack_public_path__ + "static/media/Shaman_Enhancement.13df9eda.png";